import { CountryCode } from './geo.constants';

const COUNTRY_CODE_SET: ReadonlySet<string> = new Set(Object.values(CountryCode));

export function isCountryCode(value: string): value is CountryCode {
  return COUNTRY_CODE_SET.has(value);
}

// Coerce an external country string to uppercase ISO 3166-1 alpha-2, or undefined if unrecognized.
export function normalizeCountryCode(value: string | null | undefined): CountryCode | undefined {
  if (!value) return undefined;
  const candidate = value.toUpperCase();
  return isCountryCode(candidate) ? candidate : undefined;
}
